// extracted by mini-css-extract-plugin
export default {"discountLabel":"_lmo9af","appMarketText":"_1v35x0e"};